import * as React from 'react';
import { UitkLayoutFlex } from 'uitk-react-layout-flex';
import { UitkMessagingCard, UitkMessagingCardSection } from 'uitk-react-messaging-cards';
import { ActivityDestinationViewSearch } from '../../../common/__generated__/api';
import { BannerMedia } from '../../../components/common/banners/banner-media';
import { useStores } from '../../../utils/hooks';
import { mapMessagingCardMediaProps, mapMessagingCardSectionProps } from './activity-message-banner-helper';
import { ActivityMessageBannerLink } from './activity-message-banner-link';
import ActivityMessageTile = ActivityDestinationViewSearch.ActivityMessageTileInlineFragment;

export interface ActivityMessageBannerProps extends ActivityMessageTile {
  className: string;
}

export const ActivityMessageBanner: React.FC<ActivityMessageBannerProps> = ({
  icon,
  mark,
  action,
  subtitle,
  title,
  className
}) => {
  const { analyticsStore } = useStores();

  return (
    <div className={className} data-testid="activity-message-banner">
      <UitkMessagingCard {...mapMessagingCardMediaProps(icon, mark)}>
        <BannerMedia icon={icon} mark={mark} />
        <UitkMessagingCardSection {...mapMessagingCardSectionProps(analyticsStore, title?.text, null, null)}>
          {subtitle && <p className="uitk-type-300">{subtitle.text}</p>}
          {(action?.first || action?.second) && (
            <UitkLayoutFlex space="six" className={'all-t-padding-two'}>
              {action?.first && ActivityMessageBannerLink(action.first, analyticsStore)}
              {action?.second && ActivityMessageBannerLink(action.second, analyticsStore)}
            </UitkLayoutFlex>
          )}
        </UitkMessagingCardSection>
      </UitkMessagingCard>
    </div>
  );
};
